import DownloadTicketsSection from './DownloadTicketsSection';

export default DownloadTicketsSection;
